import React from 'react';
import textService from '../services/text';
import Header from '../components/header/header';
import Footer from '../components/footer/footer';
import Meta from '../components/meta/meta';
import './contact.scss';

const Contact = () => {
  const openWhatsApp = (customMessage = '') => {
    const defaultMessage = `Hola Patio Púrpura!

Me gustaría hacer un pedido de pan de masa madre.

Mi información:
- Nombre: 
- Teléfono: 
- Email: 

Pedido:
- Tipo de pan:
- Cantidad:

Nota: Recuerdo que los pedidos se realizan antes del martes y las entregas son jueves y viernes.

Gracias!`;

    const message = customMessage || defaultMessage;
    const encodedMessage = encodeURIComponent(message);
    window.open(`https://wa.me/50688644774?text=${encodedMessage}`, '_blank');
  };



  const quickActions = [
    {
      title: 'Hacer Pedido',
      description: 'Ordena tus panes de masa madre',
      icon: '🛒',
      action: () => openWhatsApp(),
      primary: true
    },
    {
      title: 'Consulta General',
      description: 'Preguntas sobre nuestros productos',
      icon: '❓',
      action: () => openWhatsApp('Hola! Tengo algunas preguntas sobre sus panes de masa madre. ¿Podrían ayudarme?'),
      primary: false
    },
    {
      title: 'Información Masa Madre',
      description: 'Aprende sobre los beneficios',
      icon: '🍞',
      action: () => openWhatsApp('Hola! Me interesa saber más sobre los beneficios de la masa madre. ¿Podrían contarme más?'),
      primary: false
    }
  ];

  return (
    <div className="patio-purpura patio-purpura--contact">
      <Meta 
        title="Contáctanos - Patio Púrpura"
        description="Contáctanos por WhatsApp para hacer tu pedido de pan de masa madre artesanal. Pedidos antes del martes, entregas jueves y viernes."
        keywords="contacto, pedido, pan masa madre, Costa Rica, WhatsApp, email"
      />
      <Header />

      <main className="patio-purpura-content contact-content">
        <div className="contact-hero">
          <h1>Contáctanos</h1>
          <p className="contact-subtitle">
            ¿Te gustaría probar nuestros panes de masa madre? ¡Estamos aquí para ayudarte!
          </p>
          <div className="order-notice">
            <p><strong>📅 Horarios Importantes:</strong></p>
            <p>• Pedidos: <strong>Antes del martes</strong></p>
            <p>• Entrega: <strong>Jueves y Viernes</strong></p>
          </div>
        </div>

        <div className="contact-methods">
          <div className="primary-contact">
            <div className="whatsapp-card">
              <div className="whatsapp-header">
                <div className="whatsapp-icon">💬</div>
                <div className="whatsapp-info">
                  <h2>WhatsApp</h2>
                  <p>Nuestro método preferido de comunicación</p>
                </div>
              </div>
              <div className="whatsapp-actions">
                <button 
                  className="whatsapp-btn primary"
                  onClick={() => openWhatsApp()}
                >
                  <span>📱</span>
                  Hacer Pedido por WhatsApp
                </button>
              </div>
            </div>
          </div>

          <div className="quick-actions-section">
            <h3>Acciones Rápidas</h3>
            <div className="quick-actions-grid">
              {quickActions.map((action, index) => (
                <div 
                  key={index} 
                  className={`quick-action-card ${action.primary ? 'primary' : ''}`}
                  onClick={action.action}
                >
                  <div className="action-icon">{action.icon}</div>
                  <div className="action-content">
                    <h4>{action.title}</h4>
                    <p>{action.description}</p>
                  </div>
                  <div className="action-arrow">→</div>
                </div>
              ))}
            </div>
          </div>

          <div className="contact-info-section">
            <div className="info-cards">
              <div className="info-card">
                <div className="info-icon">📧</div>
                <h3>Email</h3>
                <a href={`mailto:${textService.getEmail()}`}>{textService.getEmail()}</a>
                <p>Para consultas más detalladas</p>
              </div>
              
              <div className="info-card">
                <div className="info-icon">📱</div>
                <h3>WhatsApp</h3>
                <a href="tel:+50688644774">+506 8864-4774</a>
                <p>Respuesta rápida y directa</p>
              </div>

              <div className="info-card">
                <div className="info-icon">📅</div>
                <h3>Horarios</h3>
                <p><strong>Pedidos:</strong> Antes del martes</p>
                <p><strong>Entrega:</strong> Jueves - Viernes</p>
              </div>

              <div className="info-card">
                <div className="info-icon">📸</div>
                <h3>Instagram</h3>
                <a 
                  href="https://www.instagram.com/patiopurpura" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  @patiopurpura
                </a>
                <p>Síguenos para ver nuestros panes</p>
              </div>
            </div>
          </div>

          <div className="cta-section">
            <div className="cta-content">
              <h2>¿Listo para probar nuestros panes?</h2>
              <p>Haz tu pedido antes del martes y recibe tu pan fresco jueves o viernes</p>
              <button 
                className="cta-button"
                onClick={() => openWhatsApp()}
              >
                💬 Hacer Pedido por WhatsApp
              </button>
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default Contact;